import React from 'react'
import { Row, Container } from "reactstrap";
import { RiHeartLine } from "react-icons/ri";
import { OverlayTrigger, Popover} from 'react-bootstrap';

export default function Footer() {

  const popover = (
    <Popover id="popover-basic">
      <Popover.Body variant="dark">
        <span>
          Richard Afrane-Kesey - <a href="https://github.com/richard70UKGithub" target="_blank" rel="noreferrer"><b>GitHub</b></a>
          <br></br>
          Sam Hackwood - <a href="https://github.com/samhackwood" target="_blank" rel="noreferrer"><b>GitHub</b></a>
          <br></br>
          Yamily Benigni - <a href="https://github.com/yamilyn" target="_blank" rel="noreferrer"><b>GitHub</b></a>
        </span>
      </Popover.Body>
    </Popover>
  );

  const credits = (
    <Popover id="popover-basic">
      <Popover.Body variant="dark">
        <span>
          <a href="https://www.flaticon.com/free-icons/spirit" title="spirit icons">Spirit icons - Flaticon</a>
          <br></br>   
          <a href="https://zenquotes.io/" title="ZenQuotes.io">ZenQuotes.io</a>    
        </span>
      </Popover.Body>
    </Popover>
  );

  return (
    
    <div className="footer-container bg-dark">
      <Container className="text-white" >
        <footer className="footer">
            <Row>
            <div className="credits text-center">
                <span className="copyright">
                © {new Date().getFullYear()}, made with&nbsp;
                <RiHeartLine/> | Zen Journal App
                </span>

                <OverlayTrigger rootClose={true} trigger="click" placement="top" overlay={popover}>
                  <span>&nbsp;| Developers</span>
                </OverlayTrigger>

                <OverlayTrigger rootClose={true} trigger="click" placement="top" overlay={credits}>
                  <span>&nbsp;| Credits</span>
                </OverlayTrigger>

            </div>
            </Row>
        </footer>
      </Container>
    </div>
  );
}
